import { useTranslation } from 'react-i18next';

function TrustedStrip() {
  const { t } = useTranslation();
  const items = t('trusted.items', { returnObjects: true });

  return (
    <section className="trusted-strip" aria-label={t('trusted.aria')}>
      {items.map((item) => (
        <span key={item}>{item}</span>
      ))}
    </section>
  );
}

export default TrustedStrip;
